import {
  DEFAULT_WL_ORG_CONFIG,
  WLCustomerConfigContext,
  type WLOrgConfig,
  type WLOrgConfigContextProps,
} from '@talos/kyoko';
import type { PropsWithChildren } from 'react';
import { of } from 'rxjs';

const GCashConfig: WLOrgConfig = {
  ...DEFAULT_WL_ORG_CONFIG,
  theme: 'GCashTheme',
  homeCurrency: 'PHP',
  favoredPairCurrency: 'USDT',
};

const GCashConfigContextValue: WLOrgConfigContextProps = {
  config: GCashConfig,
  isLoaded: true,
  overrides: {},
  loadedConfig: of(GCashConfig),
  setOverrides: () => {},
};
// TODO(robertz): Remove this once we have conrad config
export function GCashOrgConfigProvider({ children }: PropsWithChildren) {
  return (
    <WLCustomerConfigContext.Provider value={GCashConfigContextValue}>{children}</WLCustomerConfigContext.Provider>
  );
}
